import { css } from '@adornis/chemistry/directives/css.js';
import type { CampusExercise } from '@chancenwerk/campus-learning-content/entities/CampusExercise.js';
import '@chancenwerk/components/chancen-component-card-title.js';
import { ExerciseType } from '@chancenwerk/db/enums/enums.js';
import { html, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import { CampusComponentExerciseEdit } from './campus-page-exercise-edit.js';

/**
 * @customElement campus-page-exercise-edit-serlo
 */
@customElement('campus-page-exercise-edit-serlo')
export class CampusPageExerciseEditSerlo extends CampusComponentExerciseEdit {
  static override exerciseType: number = ExerciseType.SERLO;
  static override exerciseName: string = 'SERLO Aufgabe';
  static override exerciseElement: string = 'campus-page-exercise-edit-serlo';

  protected override getExcersiseType(): number {
    return CampusPageExerciseEditSerlo.exerciseType;
  }

  protected override getExcersieName(): string {
    return CampusPageExerciseEditSerlo.exerciseName;
  }

  constructor() {
    super();
  }

  protected override async handleFormSuccess(exercise: CampusExercise): Promise<void> {
    if (exercise.serloContentID === '') return this.errorMsg.next('Bitte eine Serlo Inhalt-ID eingeben!');
    return super.handleFormSuccess(exercise);
  }

  override content() {
    return html`
      ${this.errorMsg.value ? html`<cr-text ${css({ color: 'red' })}>${this.errorMsg.value}</cr-text>` : nothing}
      <cr-card space="md" padding="md">
        <cr-flex horizontal space="md">
          <cr-flex flex space="md">
            <cr-flex space="md" space-between>
              <cr-text>Felder mit einem * müssen ausgefüllt werden!</cr-text>
              <cr-input ${this.form.field('title')} placeholder="Titel *"></cr-input>
              <cr-input ${this.form.field('serloContentID')} placeholder="Serlo Aufgaben-ID *"></cr-input>
              <cr-link href="https://de.serlo.org/" target="_blank"><cr-text>Serlo Inhalt-ID finden</cr-text></cr-link>
            </cr-flex>
          </cr-flex>
        </cr-flex>
      </cr-card>
    `;
  }
}
